<template>
    <div class="pl-10 pr-10 ml-10 mr-10 " 
    style="    
        padding-top: 20px;
        background-color: #f3f3f3;
        padding: 20px 20px 10px 20px;
        margin-left: 18vw!important;
        margin-rigth:auto;
        margin-bottom: 20px;
        margin-top: 20px;
        border-radius: 3px;
        width:60vw;
        height:100%;
    ">
       <v-container style="font-family: 'Raleway', Arial, Helvetica, sans-serif;">
           <v-expansion-panels>
                <v-expansion-panel
                v-for="(item,i) in ediciones"
                :key="i"
                >
                <v-expansion-panel-header class="text-uppercase font-weight-bold">
                     {{item.nombre + " " + (item.año.length > 0 ? " - "+ item.año : "") }} 
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-card
                        class="mx-auto" 
                        outlined
                    >
                        <v-list-item three-line>
                        <v-list-item-content>
                            <div class="overline mb-4">
                            <h3>{{ item.fechas }}</h3>
                                <div class="mt-1">
                                    <h3>Lugar:<span class="font-weight-black"> {{ item.lugar }} </span></h3>                                   
                                </div>
                            </div>
                            <template v-for="(evento,j) in item.eventos">
                                <div :key="j" class="pb-4 mb-4">
                                <v-list-item-title class="headline mb-1" style="border-bottom: 1px solid grey;">
                                Fecha: {{ evento.detalle[0].dia }}
                                </v-list-item-title>
                                <v-list-item-subtitle class="mb-4">{{ evento.titulo }}</v-list-item-subtitle>
                                <template v-for="(detalle, k) in evento.detalle">
                                    <v-row :key="k" class="grey lighten-3 pl-4 mb-1">
                                        <v-col cols="4"> {{ detalle.compositor + (detalle.pais.length > 0 ? " (" +detalle.pais + ")": "") }} </v-col>
                                        <v-col cols="4">{{ detalle.obra }} </v-col>
                                        <v-col >{{ detalle.año + (detalle.categoria.length > 0 ? " " +detalle.categoria + " ": "") + (detalle.interprete.length > 0 ? " " +detalle.interprete + " ": "")}} </v-col>
                                    </v-row>
                                </template>
                                </div>
                            </template>
                        </v-list-item-content>
                        
                        <v-list-item-avatar
                            tile
                            size="80"
                            color="grey"
                        ></v-list-item-avatar>
                        </v-list-item>
                        
                        <!-- <v-card-actions>
                        <v-btn
                            outlined
                            rounded
                            text
                        >
                            Button
                        </v-btn>
                        </v-card-actions> -->
                    </v-card>
                </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
       </v-container> 
    </div>
</template>
<script>
export default {
    data: () => ({
      ediciones:[
          {
            "año":"2001",
            "fechas":"del 10-16-2001",
            "nombre":"Concierto de música electroacústica Latinoamericana",
            "lugar":"SCD",
            "organizador":"CMT",
            "eventos":
            [
                { 
                "titulo": "Concierto de música electroacústica Latinoamericana",
                    "detalle":[
                        {
                        "dia":"10-16-2001",
                        "compositor":"Catalina Peralta",
                        "pais":"Colombia",
                        "obra":"Recitativo Electrónico II",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2001",
                        "compositor":"Eduardo Kacheli",
                        "pais":"Argentina",
                        "obra":"La Rueda del Tiempo",
                        "año":"1998",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2001",
                        "compositor":"Juan Blanco",
                        "pais":"Cuba",
                        "obra":"5 Epitafios",
                        "año":"1992",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2001",
                        "compositor":"Gonzalo Macías",
                        "pais":"México",
                        "obra":"La Mise a Mort",
                        "año":"1994",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2001",
                        "compositor":"Flo Menézes",
                        "pais":"Brasil",
                        "obra":"PAN: Laceramento della Parola",
                        "año":"1987-1988",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2001",
                        "compositor":"Rolando Cori",
                        "pais":"Chile",
                        "obra":"Bailecitos con la Novia",
                        "año":"1999",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                }
            ]
        },
        {
            "año":"2001",
            "fechas":"12-12-2001",
            "nombre":"Concierto de música electroacústica Chilena",
            "lugar":"SCD",
            "organizador":"CMT",
            "eventos":
            [
                { 
                "titulo": "Concierto de música electroacústica Chilena",
                    "detalle":[
                        {
                        "dia":"12-12-2001",
                        "compositor":"Roque Rivas",
                        "pais":"Chile",
                        "obra":"Estudio Nocturno",
                        "año":"2000",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"12-12-2001",
                        "compositor":"Federico Schumacher",
                        "pais":"Chile",
                        "obra":"Dos piecesillas sospechosas, diríamos: Palabras del sur",
                        "año":"1999",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"12-12-2001",
                        "compositor":"Federico Schumacher",
                        "pais":"Chile",
                        "obra":"Dos piecesillas sospechosas, diríamos: On the radio, oh, oh, oh",
                        "año":"2001",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"12-12-2001",
                        "compositor":"Jorge Martínez Ulloa",
                        "pais":"Chile",
                        "obra":"Proteo (Objeto para amar, oír e interpretar): Ritmos",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"12-12-20011",
                        "compositor":"Jorge Martínez Ulloa",
                        "pais":"Chile",
                        "obra":"Proteo (Objeto para amar, oír e interpretar): Atardecer",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"12-12-2001",
                        "compositor":"Cecilia García-Gracia",
                        "pais":"Chile",
                        "obra":"La Violación de Lucrecia",
                        "año":"1999",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"12-12-20011",
                        "compositor":"José Miguel Candela",
                        "pais":"Chile",
                        "obra":"Ciclo DJ (a la manera de Ahmed Malek): DJ3",
                        "año":"2000-2001",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"12-12-20011",
                        "compositor":"José Miguel Candela",
                        "pais":"Chile",
                        "obra":"Ciclo DJ (a la manera de Ahmed Malek): DJ4",
                        "año":"2000-2001",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                }
            ]
        },
        {
            "año":"2002",
            "fechas":"del 01-10-2002 al  8-10-2002",
            "nombre":"Segundo Ciclo Internacional de Música Electroacústica",
            "lugar":"SCD",
            "organizador":"CMT/CECH",
            "eventos":
            [
                { 
                "titulo": "Concierto Internacional 1",
                    "detalle":[
                        {
                        "dia":"10-01-2002",
                        "compositor":"Juán Amenabar",
                        "pais":"Chile",
                        "obra":"Peces",
                        "año":"1957",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-01-2002",
                        "compositor":"Kaleb Tiits",
                        "pais":"Finlandia",
                        "obra":"Vox Númica",
                        "año":"2001",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-01-2002",
                        "compositor":"Elsa Justel",
                        "pais":"Argentina",
                        "obra":"GWERZ",
                        "año":"2002",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-01-2002",
                        "compositor":"Shahrokh Yadegari",
                        "pais":"Irán",
                        "obra":"Tear",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-01-2002",
                        "compositor":"Gonzalo Biffarella",
                        "pais":"Argentina",
                        "obra":"Requiem AR.02",
                        "año":"2002",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-01-2002",
                        "compositor":"Christine Groult",
                        "pais":"Francia",
                        "obra":"Passagers Imminents",
                        "año":"1993",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                    "titulo": "Concierto-Homenaje a Carlos Fariña",
                    "detalle":[
                        {
                            "dia":"10-02-2002",
                            "compositor":"Carlos Fariñas",
                            "pais":"Cuba",
                            "obra":"Órbitas Elípticas",
                            "año":"2002",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-02-2002",
                            "compositor":"Gustavo Becerra-Schmidt",
                            "pais":"Chile",
                            "obra":"Interior",
                            "año":"1987",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-02-2002",
                            "compositor":"Teresa Nuñez",
                            "pais":"Cuba",
                            "obra":"Con Puntos y Comas",
                            "año":"2001",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-02-2002",
                            "compositor":"Irina Escalante",
                            "pais":"Cuba",
                            "obra":"La Primavera del Angel",
                            "año":"2000",
                            "categoria":"Mixta",
                            "interprete":"Josetxo Silguero Gorriti (Sx)"
                        },
                        {
                            "dia":"10-02-2002",
                            "compositor":"Mónica O'Reilly",
                            "pais":"Cuba",
                            "obra":"Tres Little Escenas de Mr. Pérez",
                            "año":"2002",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-02-2002",
                            "compositor":"Mónica O'Reilly",
                            "pais":"Cuba",
                            "obra":"El Segundo de un Compay Eterno",
                            "año":"2000",
                            "categoria":"",
                            "interprete":""
                        }
                    ]
                },
                { 
                    "titulo": "Concierto Internacional 2",
                    "detalle":[
                        {
                            "dia":"10-08-2002",
                            "compositor":"Cristian Morales-Ossio",
                            "pais":"Chile",
                            "obra":"RisRas",
                            "año":"1997",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-08-2002",
                            "compositor":"Pietro Polotti",
                            "pais":"Italia",
                            "obra":"1948",
                            "año":"1998",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-08-2002",
                            "compositor":"Beatriz Ferreyra",
                            "pais":"Argentina",
                            "obra":"Cantos de Antes",
                            "año":"2002",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-08-2002",
                            "compositor":"Phillippe Leroux",
                            "pais":"Francia",
                            "obra":"M.E. 1) Approcher 2) Sentir 3) Dire",
                            "año":"1998",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-08-2002",
                            "compositor":"Joao Pedro Oliveira",
                            "pais":"Portugal",
                            "obra":"Mahakala Sadhana",
                            "año":"2000",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-08-2002",
                            "compositor":"Ahmed Malek",
                            "pais":"Argelia",
                            "obra":"Cuba Sí",
                            "año":"2000",
                            "categoria":"",
                            "interprete":""
                        }
                    ]
                }
            ]
        },
        {
            "año":"2003",
            "fechas":"del 14-10-2003 al  18-10-2003",
            "nombre":"Tercer Ciclo Internacional de conciertos de Música Electroacústica",
            "lugar":"SCD",
            "organizador":"CMT/CECH",
            "eventos":
            [
                { 
                "titulo": "Homenaje a Luciano Berio",
                    "detalle":[
                        {
                        "dia":"10-14-2003",
                        "compositor":"Luciano Berio",
                        "pais":"Italia",
                        "obra":"Thema (Omaggio a Joyce)",
                        "año":"1958",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-14-2003",
                        "compositor":"Luciano Berio",
                        "pais":"Italia",
                        "obra":"Visage",
                        "año":"1961",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-14-2003",
                        "compositor":"Ernesto Holman Grossi",
                        "pais":"Chile",
                        "obra":"Oireb-A",
                        "año":"1994",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-14-2003",
                        "compositor":"Flo Menezes",
                        "pais":"Brasil",
                        "obra":"Contextures-I",
                        "año":"1988-1989",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-14-2003",
                        "compositor":"Gabriel Brncic",
                        "pais":"Chile",
                        "obra":"Clarinen Tres",
                        "año":"1986",
                        "categoria":"Mixta",
                        "interprete":"Thomas Thayer (Fl)"
                        }
                    ]
                },
                { 
                "titulo": "Concierto Latinoamericano 1: Argentina",
                    "detalle":[
                        {
                        "dia":"10-15-2003",
                        "compositor":"Edgardo Cantón",
                        "pais":"Chile",
                        "obra":"Los Sueños de Attar",
                        "año":"2003",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-15-2003",
                        "compositor":"Guillermo Rizzotto",
                        "pais":"Argentina",
                        "obra":"The Noises of my Mind",
                        "año":"2003",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-15-2003",
                        "compositor":"Ricardo del Farra",
                        "pais":"Argentina",
                        "obra":"Due Giorni Doppo",
                        "año":"1988",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-15-2003",
                        "compositor":"Teodoro Cromberg",
                        "pais":"Argentina",
                        "obra":"Añoranza de lo Dionisiaco",
                        "año":"1996",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-15-2003",
                        "compositor":"Mario Mary",
                        "pais":"Argentina",
                        "obra":"Signes Emergentes",
                        "año":"2003",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-15-2003",
                        "compositor":"Gonzalo Biffarella",
                        "pais":"Argentina",
                        "obra":"Mestizaje (Homenaje a Pompi)",
                        "año":"1993-1994",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-15-2003",
                        "compositor":"Jorge Rapp",
                        "pais":"Argentina",
                        "obra":"Tiempos Virtuales",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-15-2003",
                        "compositor":"Raul Minsburg",
                        "pais":"Argentina",
                        "obra":"Entre Sueños",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-15-2003",
                        "compositor":"Enrique Belloc",
                        "pais":"Argentina",
                        "obra":"Remix Portraits",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto Internacional/CIME",
                    "detalle":[
                        {
                        "dia":"10-16-2003",
                        "compositor":"Felipe Otondo",
                        "pais":"Chile",
                        "obra":"Constelaciones 1",
                        "año":"2003",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2003",
                        "compositor":"Miguel Azguime",
                        "pais":"portugal",
                        "obra":"Comunicacoes",
                        "año":"1998",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2003",
                        "compositor":"Teodor Todoroff",
                        "pais":"Bélgica",
                        "obra":"Voices Part II",
                        "año":"1999",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2003",
                        "compositor":"David Berezan",
                        "pais":"Canadá",
                        "obra":"Baoding",
                        "año":"2002",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2003",
                        "compositor":"Ricardo Mandolini",
                        "pais":"Argentina",
                        "obra":"La Noche en que los Peces Flotaron",
                        "año":"2003",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2003",
                        "compositor":"Francois Bayle",
                        "pais":"Francia",
                        "obra":"Le Sommeil d'Euclide",
                        "año":"1983",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2003",
                        "compositor":"John Young",
                        "pais":"USA",
                        "obra":"Toungue",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto Latinoamericano 2",
                    "detalle":[
                        {
                        "dia":"10-17-2003",
                        "compositor":"Adolfo Kaplan",
                        "pais":"Chile",
                        "obra":"Las Trayectorias de Réve",
                        "año":"2003",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2003",
                        "compositor":"Eduardo Reck Miranda",
                        "pais":"Brasil",
                        "obra":"Olivine Trees",
                        "año":"1993",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2003",
                        "compositor":"Rodrigo Sigal",
                        "pais":"México",
                        "obra":"Frictions of Things in Other Places",
                        "año":"2002",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2003",
                        "compositor":"Carlos Vázquez",
                        "pais":"Puerto Rico",
                        "obra":"Aquél Album",
                        "año":"2002",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2003",
                        "compositor":"Arturo Rodas",
                        "pais":"Ecuador",
                        "obra":"Fermez les Yeux SVP",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2003",
                        "compositor":"Roberto Valerae",
                        "pais":"Cuba",
                        "obra":"Palmas",
                        "año":"1992",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2003",
                        "compositor":"Horacio Vaggione",
                        "pais":"Argentina",
                        "obra":"24 Variaciones",
                        "año":"2001",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2003",
                        "compositor":"Germán Toro",
                        "pais":"Colombia",
                        "obra":"Estudio de Ruidos y Campanas",
                        "año":"1996",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Homenaje a los 70 años de José Vicente Asuar",
                    "detalle":[
                        {
                        "dia":"10-18-2003",
                        "compositor":"José Vicente Asuar",
                        "pais":"Chile",
                        "obra":"Variaciones Espectrales",
                        "año":"1959",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2003",
                        "compositor":"José Vicente Asuar",
                        "pais":"Chile",
                        "obra":"Guararia Repano",
                        "año":"1968",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2003",
                        "compositor":"José Vicente Asuar",
                        "pais":"México",
                        "obra":"Affaires de Oiseaux",
                        "año":"1976",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Compositores Chilenos",
                    "detalle":[
                        {
                        "dia":"10-18-2003",
                        "compositor":"José Miguel Candela",
                        "pais":"Chile",
                        "obra":"Delta",
                        "año":"2002",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2003",
                        "compositor":"Cecilia García",
                        "pais":"Chile",
                        "obra":"Werika",
                        "año":"2003",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2003",
                        "compositor":"Federico Schumacher",
                        "pais":"Chile",
                        "obra":"On the Radio, Oh, Oh, Oh",
                        "año":"2001",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2003",
                        "compositor":"Paola Lazo",
                        "pais":"Chile",
                        "obra":"Medusa",
                        "año":"2003",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2003",
                        "compositor":"Oscar Carmona",
                        "pais":"Chile",
                        "obra":"Cygnus X-1",
                        "año":"2003",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2003",
                        "compositor":"Felix Lazo",
                        "pais":"Chile",
                        "obra":"Les Filles du Mara",
                        "año":"2003",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                }
            ]
        },
        {
            "año":"2005",
            "fechas":"del 17-10-2005 al 22-10-2005",
            "nombre":"V Festival Internaconal de Música Electroacústica de Santiago AI-Maako",
            "lugar":"CCE",
            "organizador":"CMT/CECH",
            "eventos":
            [
                { 
                "titulo": "Concierto Inaugural",
                    "detalle":[
                        {
                        "dia":"10-17-2005",
                        "compositor":"José Vicente Asuar",
                        "pais":"Chile",
                        "obra":"En el Jardín",
                        "año":"1985",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2005",
                        "compositor":"Adolfo Nuñez",
                        "pais":"España",
                        "obra":"Yacimiento Ignorado",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2005",
                        "compositor":"Matías Troncoso",
                        "pais":"Chile",
                        "obra":"En",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2005",
                        "compositor":"Diego Garro",
                        "pais":"Italia-UK",
                        "obra":"O que a Menina Ouye",
                        "año":"2004",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2005",
                        "compositor":"Santiago Diez",
                        "pais":"Argentina",
                        "obra":"Graphyas",
                        "año":"2005",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2005",
                        "compositor":"Gabriel Brncic",
                        "pais":"Chile",
                        "obra":"Que no Desorganitza Cap Murmuri (a Joan Brossa)",
                        "año":"1994",
                        "categoria":"Mixta",
                        "interprete":"Paola Muñoz (Fl)"
                        }
                    ]
                },
                { 
                "titulo": "Otras Músicas para Saxofón y Electroacústica",
                    "detalle":[
                        {
                        "dia":"10-18-2005",
                        "compositor":"Jean Claude Risset",
                        "pais":"Francia",
                        "obra":"Voilements",
                        "año":"1987",
                        "categoria":"Mixta",
                        "interprete":"Josetxo Silguero Gorriti (Sx)"
                        },
                        {
                        "dia":"10-18-2005",
                        "compositor":"José Manuel López López",
                        "pais":"España",
                        "obra":"Con Cadencia de Eternidad",
                        "año":"1989-2002",
                        "categoria":"Mixta",
                        "interprete":"Josetxo Silguero Gorriti (Sx)"
                        },
                        {
                        "dia":"10-18-2005",
                        "compositor":"Alfonso García de la Torre",
                        "pais":"España",
                        "obra":"Un Caracol Manchado",
                        "año":"2000",
                        "categoria":"Mixta",
                        "interprete":"Josetxo Silguero Gorriti (Sx)"
                        },
                        {
                        "dia":"10-18-2005",
                        "compositor":"Ignacio Monterrubio",
                        "pais":"España",
                        "obra":"Visages",
                        "año":"2004",
                        "categoria":"Mixta",
                        "interprete":"Josetxo Silguero Gorriti (Sx)"
                        },
                        {
                        "dia":"10-18-2005",
                        "compositor":"Guillermo Lauzurica",
                        "pais":"España",
                        "obra":"Solo",
                        "año":"1998",
                        "categoria":"mixta",
                        "interprete":"Josetxo Silguero Gorriti (Sx)"
                        }
                    ]
                },
                { 
                "titulo": "Concierto Internacional A",
                    "detalle":[
                        {
                        "dia":"10-18-2005",
                        "compositor":"Marcelo Espíndola",
                        "pais":"Chile",
                        "obra":"Lauch 1",
                        "año":"2005",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2005",
                        "compositor":"Tim Howle",
                        "pais":"UK",
                        "obra":"Subplot Revision",
                        "año":"2005",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2005",
                        "compositor":"Francesco Biasiol",
                        "pais":"Italia-UK",
                        "obra":"November 1952",
                        "año":"",
                        "categoria":"Open",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2005",
                        "compositor":"Pete Stolleri",
                        "pais":"UK",
                        "obra":"Serendipities and Synchronicities",
                        "año":"2004",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2005",
                        "compositor":"Paul Rudy",
                        "pais":"USA",
                        "obra":"Love Song",
                        "año":"2003",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2005",
                        "compositor":"Jean Francois Cavro",
                        "pais":"Francia",
                        "obra":"Le Contour d'un Helicoptére Sinuait sur la Cendrée d'un Court de Tennis tel le Profil d'un Ange",
                        "año":"2005",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Carta Blanca Andrés Lewin-Richter",
                    "detalle":[
                        {
                        "dia":"10-19-2005",
                        "compositor":"Edgar Barroso",
                        "pais":"México",
                        "obra":"Tu Mateix",
                        "año":"2004",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-19-2005",
                        "compositor":"Andrés Lewin-Richter",
                        "pais":"España",
                        "obra":"Figuras",
                        "año":"2000",
                        "categoria":"Mixta",
                        "interprete":"Josetxo Silguero Gorriti (Sx)"
                        },
                        {
                        "dia":"10-19-2005",
                        "compositor":"Alex Sanjurjo/Léximel Jélimite",
                        "pais":"España",
                        "obra":"Fluir",
                        "año":"2002",
                        "categoria":"Audiovisual",
                        "interprete":"n/a"
                        },
                        {
                        "dia":"10-19-2005",
                        "compositor":"Andrés Lewin-Richter",
                        "pais":"España",
                        "obra":"Caminando… (Recuerdos de Nicolás Guillén)",
                        "año":"2002",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto Internacional B",
                    "detalle":[
                        {
                        "dia":"10-19-2005",
                        "compositor":"Adolfo Kaplán",
                        "pais":"Chile",
                        "obra":"Trayectorias del Sueño",
                        "año":"2003",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-19-2005",
                        "compositor":"John Young",
                        "pais":"Noruega-UK",
                        "obra":"Siu",
                        "año":"1999",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-19-2005",
                        "compositor":"Guillermo Rizzotto",
                        "pais":"Argentina",
                        "obra":"Canto de mi Tierra",
                        "año":"2004",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-19-2005",
                        "compositor":"Roger Cochini",
                        "pais":"Francia",
                        "obra":"La Schiuma dei Rumori",
                        "año":"1999-2000",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-19-2005",
                        "compositor":"Panayiotis Kokoras",
                        "pais":"Grecia",
                        "obra":"Slide",
                        "año":"2002",
                        "categoria":"Mixta",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto de Obras Chilenas \"Memoria Electroacústica Chilena\". Curado por Federico Schumacher",
                    "detalle":[
                        {
                        "dia":"10-20-2005",
                        "compositor":"Jorge Arriagada",
                        "pais":"Chile",
                        "obra":"Indio (Solstice d'hiver des Saisons)",
                        "año":"1972",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2005",
                        "compositor":"Samuel Claro",
                        "pais":"Chile",
                        "obra":"Estudio N°1",
                        "año":"1960",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2005",
                        "compositor":"Francesca Ancarola",
                        "pais":"Chile",
                        "obra":"A",
                        "año":"1976",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2005",
                        "compositor":"Juan Lemann",
                        "pais":"Chile",
                        "obra":"Teorema",
                        "año":"1976",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2005",
                        "compositor":"Juan Amenábar",
                        "pais":"Chile",
                        "obra":"Cantigas en el Umbral",
                        "año":"1997",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2005",
                        "compositor":"José Vicente Asuar",
                        "pais":"Chile",
                        "obra":"El Preludio La Noche",
                        "año":"1961",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2005",
                        "compositor":"Iván Pequeño",
                        "pais":"Chile",
                        "obra":"Ahora",
                        "año":"1974",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto Internacional C",
                    "detalle":[
                        {
                        "dia":"10-20-2005",
                        "compositor":"Rodrigo Sigal",
                        "pais":"México",
                        "obra":"Twilight",
                        "año":"2001",
                        "categoria":"Mixta",
                        "interprete":"Jorge Espinoza (Fg)"
                        },
                        {
                        "dia":"10-20-2005",
                        "compositor":"José Miguel Fernández",
                        "pais":"Chile",
                        "obra":"9dN.13 (Viaje_Espacio_Continuo)",
                        "año":"2002",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2005",
                        "compositor":"Lennart Westman",
                        "pais":"Suecia",
                        "obra":"Lapides",
                        "año":"2005",
                        "categoria":"Mixta",
                        "interprete":"Gonzalo Cuadra (Tenor)"
                        },
                        {
                        "dia":"10-20-2005",
                        "compositor":"Thomas Gerwin",
                        "pais":"Alemania",
                        "obra":"Kurzgeschichten/Short Stories",
                        "año":"1995-1998",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2005",
                        "compositor":"Jean Michel Robert",
                        "pais":"Canadá",
                        "obra":"Si",
                        "año":"2005",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2005",
                        "compositor":"Frank Ekberg",
                        "pais":"Noruega-UK",
                        "obra":"(Des)integración",
                        "año":"1998",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto Homenaje a Gustavo Becerra-Schmidt en su 80° aniversario",
                    "detalle":[
                        {
                        "dia":"10-21-2005",
                        "compositor":"Gustavo Becerra-Schmidt",
                        "pais":"Chile",
                        "obra":"Batuque",
                        "año":"1971",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-21-2005",
                        "compositor":"Gustavo Becerra-Schmidt",
                        "pais":"Chile",
                        "obra":"Cornos Volantes",
                        "año":"1974",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-21-2005",
                        "compositor":"Gustavo Becerra-Schmidt",
                        "pais":"Chile",
                        "obra":"Quipus",
                        "año":"1978-1980",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-21-2005",
                        "compositor":"Gustavo Becerra-Schmidt",
                        "pais":"Chile",
                        "obra":"Concierto para 4 Pianos Sampleados",
                        "año":"2004",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto TallerElectro - \"Un año más\"",
                    "detalle":[
                        {
                        "dia":"10-21-2005",
                        "compositor":"Gino Fuenzalida",
                        "pais":"Chile",
                        "obra":"Ciclo global",
                        "año":"2005",
                        "categoria":"Improvisación",
                        "interprete":"Gino Fuenzalida"
                        },
                        {
                        "dia":"10-21-2005",
                        "compositor":"Gerardo Figueroa",
                        "pais":"Chile",
                        "obra":"Planderfonia",
                        "año":"2002- 2005",
                        "categoria":"Improvisación",
                        "interprete":"Gerardo Figueroa"
                        },
                        {
                        "dia":"10-21-2005",
                        "compositor":"Esteban Anavitarte",
                        "pais":"Chile",
                        "obra":"No bajes tu live",
                        "año":"2005",
                        "categoria":"Improvisación",
                        "interprete":"Esteban Anavitarte"
                        },
                        {
                        "dia":"10-21-2005",
                        "compositor":"Electrodo Ensamble",
                        "pais":"Chile",
                        "obra":"Concierto TallerElectro",
                        "año":"2005",
                        "categoria":"Improvisación",
                        "interprete":"Electrodo Ensamble"
                        }
                    ]
                },
                { 
                "titulo": "Concierto Internacional D",
                    "detalle":[
                        {
                        "dia":"10-22-2005",
                        "compositor":"Andrian Pertour",
                        "pais":"Chile-Australia",
                        "obra":"Pañc Hãzar Chakrã Kaï Andar",
                        "año":"2000",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-22-2005",
                        "compositor":"Flo Menezes",
                        "pais":"Brasil",
                        "obra":"Todos os Cantos: I Stretto; II Rubato",
                        "año":"2004-2005",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-22-2005",
                        "compositor":"Trevor Wishart",
                        "pais":"UK",
                        "obra":"Memories of Madrid",
                        "año":"2005",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-22-2005",
                        "compositor":"Hans Tutschku",
                        "pais":"Alemania",
                        "obra":"… erinnerung (Memento)",
                        "año":"1996",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-22-2005",
                        "compositor":"Francis Dhomont",
                        "pais":"Francia-Canadá",
                        "obra":"Vol d'arandes",
                        "año":"1999-2001",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto Miembros CECH",
                    "detalle":[
                        {
                        "dia":"10-22-2005",
                        "compositor":"Paola Lazo",
                        "pais":"Chile",
                        "obra":"Oxasavala",
                        "año":"2005",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-22-2005",
                        "compositor":"José Miguel Candela",
                        "pais":"Chile",
                        "obra":"Micro-Ciclo \"Un Camino Nuevo\"",
                        "año":"2005",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-22-2005",
                        "compositor":"Felix Lazo",
                        "pais":"Chile",
                        "obra":"Earth",
                        "año":"2004",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-22-2005",
                        "compositor":"Cecilia García Gracia",
                        "pais":"Chile",
                        "obra":"Shantih Aum",
                        "año":"2005",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-22-2005",
                        "compositor":"Juan Mendoza",
                        "pais":"Chile",
                        "obra":"SAL",
                        "año":"2005",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-22-2005",
                        "compositor":"Alejandro Albornoz",
                        "pais":"Chile",
                        "obra":"Noche de Metales (Segunda Parte)",
                        "año":"2005",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-22-2005",
                        "compositor":"Felipe Otondo",
                        "pais":"Chile",
                        "obra":"Plastiches",
                        "año":"2005",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-22-2005",
                        "compositor":"Jorge Sacaan",
                        "pais":"Chile",
                        "obra":"Tambor Parlante",
                        "año":"2005",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                }
            ]
        },
        {
            "año":"2007",
            "fechas":"del 13-10-2007 al 20-10-2007",
            "nombre":"VII Festival Internaconal de Música Electroacústica de Santiago, AI-Maako",
            "lugar":"BS,CCE",
            "organizador":"CECH",
            "eventos":
            [
                { 
                "titulo": "Concierto Gratuito al Aire Libre 1",
                    "detalle":[
                        {
                        "dia":"10-13-2007",
                        "compositor":"Stefano Scarani/Alberto Morelli",
                        "pais":"Italia",
                        "obra":"Megalopolis",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"Panayiotis Kokoras",
                        "pais":"Grecia",
                        "obra":"Anechoic Pulse",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"Félix Lazo",
                        "pais":"Chile",
                        "obra":"Earth",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"Beatriz Ferreyra",
                        "pais":"Argentina",
                        "obra":"Jazz't for Miles",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"Trevor Wishart",
                        "pais":"UK",
                        "obra":"Tongues of Fire",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto Gratuito al Aire Libre 2",
                    "detalle":[
                        {
                        "dia":"10-13-2007",
                        "compositor":"David Berezan",
                        "pais":"Canadá",
                        "obra":"Cyclo",
                        "año":"1987",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"José Miguel Candela",
                        "pais":"Chile",
                        "obra":"Bajan Gritando Ellos",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"Joao Pedro Oliveira",
                        "pais":"Portugal",
                        "obra":"Mahakala Sadhana",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"Sebastien Berenger",
                        "pais":"Francia",
                        "obra":"Schizo a 120",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"Javier Alvarez",
                        "pais":"México",
                        "obra":"Mambro a la Braque",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"Felipe Otondo",
                        "pais":"Chile",
                        "obra":"Zapping Zappa",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"Alejandro Albornoz",
                        "pais":"Chile",
                        "obra":"Noche de Metales",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto Gratuito al Aire Libre 3",
                    "detalle":[
                        {
                        "dia":"10-13-2007",
                        "compositor":"Elsa Justel",
                        "pais":"Argentina",
                        "obra":"Un Regard sur la Ville",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"Adolfo Kaplan",
                        "pais":"Chile",
                        "obra":"Hors Chant",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"Federico Schumacher",
                        "pais":"Chile",
                        "obra":"Jetlag+6 Hrs",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"Ake Parmerud",
                        "pais":"Suecia",
                        "obra":"Les Flutes en Feu",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"Gabriel Brncic",
                        "pais":"CHile",
                        "obra":"Adagio-Scherzo (Homenaje a Victor Jara)",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2007",
                        "compositor":"Christine Groult",
                        "pais":"Francia",
                        "obra":"La Condition Captive",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto Inaugural Ai Maako 2007",
                    "detalle":[
                        {
                        "dia":"10-15-2007",
                        "compositor":"Maark Applebaum",
                        "pais":"USA",
                        "obra":"Precomposition",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-15-2007",
                        "compositor":"Phillippe Manoury",
                        "pais":"Francia",
                        "obra":"Jupiter",
                        "año":"2000",
                        "categoria":"Mixta",
                        "interprete":"Patricio de la Cuadra (Fl), Rodrigo Cádiz (C)"
                        }
                    ]
                },
                { 
                "titulo": "Carta Blanca a Trevor Wishart",
                    "detalle":[
                        {
                        "dia":"10-15-2007",
                        "compositor":"Trevor Wishart",
                        "pais":"UK",
                        "obra":"Globalalia",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-15-2007",
                        "compositor":"Trevor Wishart",
                        "pais":"UK",
                        "obra":"Imago",
                        "año":"1999",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto Selección Internacional A",
                    "detalle":[
                        {
                        "dia":"10-16-2007",
                        "compositor":"Daniel Jeffs",
                        "pais":"Chile",
                        "obra":"A-gain",
                        "año":"1972",
                        "categoria":"Mixta",
                        "interprete":"Karenn Conzalez (Vx) Daniel Jeffs (C) "
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"Juan Mendoza",
                        "pais":"Chile",
                        "obra":"Recintos de Entropía",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"Marco Marini",
                        "pais":"Francia",
                        "obra":"Three Bags from Birmingham for the Bag-Pipe Computer",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"LeoKupper",
                        "pais":"Bélgica",
                        "obra":"Paroles sur Lévres",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"Volker Hennes",
                        "pais":"Alemania",
                        "obra":"Piece de derriere N°3",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"Daniel Schachter",
                        "pais":"Argentina",
                        "obra":"Líneas y Puntos de Otro Tiempo",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"Stefano Trevisi",
                        "pais":"Italia",
                        "obra":"Swallow",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"Raúl Minsburg",
                        "pais":"Argentina",
                        "obra":"Cantos Lejanos",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Carta Blanca a Gabriel Brncic",
                    "detalle":[
                        {
                        "dia":"10-16-2007",
                        "compositor":"Gabriel Brncic",
                        "pais":"Chile",
                        "obra":"Concierto-Gótico; 1a parte: Trabaja el Organero",
                        "año":"2001",
                        "categoria":"Mixta",
                        "interprete":"Jorge Espinoza (Fg)"
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"Gabriel Brncic",
                        "pais":"Chile",
                        "obra":"Alegrías",
                        "año":"",
                        "categoria":"Mixta",
                        "interprete":"José Miguel Candela (GE)"
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"Gabriel Brncic",
                        "pais":"Chile",
                        "obra":"Concierto-Gótico; 3a parte: Sueño de Oboe",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"Cristian Morales Ossio",
                        "pais":"Chile",
                        "obra":"Oda",
                        "año":"",
                        "categoria":"Mixta",
                        "interprete":"Felipe Vieytes (Vla), Paola Muñoz (FD)"
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"Gabriel Brncic",
                        "pais":"Chile",
                        "obra":"Clarinen Tres",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"Federico Schumacher",
                        "pais":"Chile",
                        "obra":"Print",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"Gabriel Brncic",
                        "pais":"Chile",
                        "obra":"La Casa del Viento IV",
                        "año":"",
                        "categoria":"Mixta",
                        "interprete":"Dante Burotto (Cl)"
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"Gabriel Brncic",
                        "pais":"Chile",
                        "obra":"Concierto-Gótico; 4a parte: Capricho de Piedra",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-16-2007",
                        "compositor":"Gabriel Brncic",
                        "pais":"Chile",
                        "obra":"…que no desorganiza cap murmuri",
                        "año":"",
                        "categoria":"Mixta",
                        "interprete":"Paola Muñoz (Fl)"
                        }
                    ]
                },
                { 
                "titulo": "Concierto Selección Internacional B",
                    "detalle":[
                        {
                        "dia":"10-17-2007",
                        "compositor":"Marcelo Espíndola",
                        "pais":"Chile",
                        "obra":"Ruido Fuera de Plazo",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2007",
                        "compositor":"Takuto Fukuda",
                        "pais":"Japón",
                        "obra":"Flash Back",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2007",
                        "compositor":"Arturo Parra/Stéphane Roy",
                        "pais":"Colombia/Canada",
                        "obra":"La Basilica Fantasma",
                        "año":"",
                        "categoria":"Mixta",
                        "interprete":"Héctor Cerda (Gr)"
                        },
                        {
                        "dia":"10-17-2007",
                        "compositor":"Thomas Gerwin",
                        "pais":"Alemania",
                        "obra":"b…correntes",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2007",
                        "compositor":"Ed Martin",
                        "pais":"USA",
                        "obra":"Apparitiions",
                        "año":"",
                        "categoria":"Mixta",
                        "interprete":"Miguel Villafruela (Sx)"
                        },
                        {
                        "dia":"10-17-2007",
                        "compositor":"Claudio Perugini",
                        "pais":"Italia",
                        "obra":"Pythgorean",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2007",
                        "compositor":"Cesare Saldicco",
                        "pais":"Italia",
                        "obra":"Digressione Ipertestuale n.10",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2007",
                        "compositor":"Jorge Antunes",
                        "pais":"Brasil",
                        "obra":"Rituel Violet",
                        "año":"",
                        "categoria":"Mixta",
                        "interprete":"Miguel Villafruela (Sx)"
                        }
                    ]
                },
                { 
                "titulo": "Carta Blanca a Joao Pedro Oliveira",
                    "detalle":[
                        {
                        "dia":"10-17-2007",
                        "compositor":"Mario Mary",
                        "pais":"Argentina",
                        "obra":"Signes Emergents",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2007",
                        "compositor":"Joao Pedro Oliveira",
                        "pais":"Chile",
                        "obra":"A Cidade Eterna",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2007",
                        "compositor":"Flo Menezes",
                        "pais":"Brasil",
                        "obra":"Selva Illuminata",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2007",
                        "compositor":"Hans Tutschku",
                        "pais":"Alemania",
                        "obra":"Erinnerung",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-17-2007",
                        "compositor":"Joao Pedro Oliveira",
                        "pais":"Portugal",
                        "obra":"Aphar",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto Homenaje a Juan Amenábar",
                    "detalle":[
                        {
                        "dia":"10-18-2007",
                        "compositor":"Juan Amenábar",
                        "pais":"Chile",
                        "obra":"Los Peces",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"Juan Amenábar",
                        "pais":"Chile",
                        "obra":"Ludus Vocalis",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"Juan Amenábar",
                        "pais":"Chile",
                        "obra":"Amacatá",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"José Miguel Candela",
                        "pais":"Chile",
                        "obra":"Sea Monkeys",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"Juan Mendoza/Gonzalo Aguila",
                        "pais":"Chile",
                        "obra":"PC's",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"Rolando Cori",
                        "pais":"Chile",
                        "obra":"La Ciudad Hermosa",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"Edgardo Cantón",
                        "pais":"Chile",
                        "obra":"RicordaRicardo",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"Andrián Pertout",
                        "pais":"Chile",
                        "obra":"Sonic Junk Yard for Tape",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto Selección Internacional C",
                    "detalle":[
                        {
                        "dia":"10-18-2007",
                        "compositor":"Weiwei-Lan",
                        "pais":"China",
                        "obra":"Gebrochene Klanggestalten",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"Adrián Borza",
                        "pais":"Canadá",
                        "obra":"Dusk",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"Ricardo de Armas",
                        "pais":"Argentina",
                        "obra":"Guayte Noise",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"Dominique Thibault",
                        "pais":"Canadá",
                        "obra":"Noche Negra, Noche Gris",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"Erdem Helvacioglu",
                        "pais":"Turquía",
                        "obra":"Wandering Around the City",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"Hiroki Nishino",
                        "pais":"Japón/USA",
                        "obra":"A Very Short Futuristic Sketch",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"Suk Jun Kim",
                        "pais":"Corea",
                        "obra":"Corresponding",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"Francis Dhomont",
                        "pais":"Francia",
                        "obra":"Corps et Ame",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-18-2007",
                        "compositor":"Nicolas Collins",
                        "pais":"USA",
                        "obra":"Pea Soup II",
                        "año":"",
                        "categoria":"Live Electronics",
                        "interprete":"Rodrigo Cádiz (C)"
                        }
                    ]
                },
                { 
                "titulo": "Concierto Selección Internacional D",
                    "detalle":[
                        {
                        "dia":"10-19-2007",
                        "compositor":"Jorge Martínez",
                        "pais":"Chile",
                        "obra":"Aliento, Madera, Metal",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-19-2007",
                        "compositor":"Nicolas Verin",
                        "pais":"Francia",
                        "obra":"De Trés Prés ou de Trés Loin",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-19-2007",
                        "compositor":"Jon Christopher Nelson",
                        "pais":"USA",
                        "obra":"L'horloge Imaginaire",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-19-2007",
                        "compositor":"Hans Tutschku",
                        "pais":"Alemania",
                        "obra":"Distance Liquid",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-19-2007",
                        "compositor":"Florian Zwissler",
                        "pais":"Alemania",
                        "obra":"Doppelbrunn",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-19-2007",
                        "compositor":"Eldad Tsabary",
                        "pais":"Canadá",
                        "obra":"In the Eye of the Believer",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-19-2007",
                        "compositor":"Jorge Sacaan",
                        "pais":"Chile",
                        "obra":"Afrodistante",
                        "año":"",
                        "categoria":"Live Electronics",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto Rockola Electrónica",
                    "detalle":[
                        {
                        "dia":"10-19-2007",
                        "compositor":"Gerardo Figueroa",
                        "pais":"Chile",
                        "obra":"Re-(Gue-Te)-Nacimiento",
                        "año":"",
                        "categoria":"Miniatúricacusmáticaplunderphonica con vocación de hit radial",
                        "interprete":"VJPanicovisual (VJ)"
                        },
                        {
                        "dia":"10-19-2007",
                        "compositor":"Les Chicci",
                        "pais":"Chile",
                        "obra":"Amen Amango, (hast)a la vista",
                        "año":"",
                        "categoria":"Performance con material sonoro extraido de música chilena actual",
                        "interprete":"VJPanicovisual (VJ)"
                        },
                        {
                        "dia":"10-19-2007",
                        "compositor":"Mika Martini/Oscar Chaves",
                        "pais":"Chile/Colombia",
                        "obra":"Revolver Cenizas",
                        "año":"",
                        "categoria":"Improvisación a partir del tema \"Cenizas\" de Lluvia Ácida",
                        "interprete":"VJPanicovisual (VJ)"
                        },
                        {
                        "dia":"10-19-2007",
                        "compositor":"Mario Feito/Alejandro Albornoz",
                        "pais":"Chile",
                        "obra":"sin título",
                        "año":"",
                        "categoria":"Improvisación para teclado, computador y soporte",
                        "interprete":"VJPanicovisual (VJ)"
                        },
                        {
                        "dia":"10-19-2007",
                        "compositor":"Asolaar",
                        "pais":"Argentina",
                        "obra":"Sincro",
                        "año":"",
                        "categoria":"Live Electronics",
                        "interprete":""
                        },
                        {
                        "dia":"10-19-2007",
                        "compositor":"Alisú",
                        "pais":"Chile",
                        "obra":"Fotogramas",
                        "año":"",
                        "categoria":"Live Electronics",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto Invisible Music: Carta Blanca a Ake Parmerud",
                    "detalle":[
                        {
                        "dia":"10-20-2007",
                        "compositor":"Ake Parmerud",
                        "pais":"Suecia",
                        "obra":"Dreaming in Darkness",
                        "año":"",
                        "categoria":"Miniatúricacusmáticaplunderphonica con vocación de hit radial",
                        "interprete":"VJPanicovisual (VJ)"
                        },
                        {
                        "dia":"10-20-2007",
                        "compositor":"Ake Parmerud",
                        "pais":"Suecia",
                        "obra":"Bows, Arcs &The Arrow of Time",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2007",
                        "compositor":"Ake Parmerud",
                        "pais":"Suecia",
                        "obra":"La Vie Mécanique",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2007",
                        "compositor":"Ake Parmerud",
                        "pais":"Suecia",
                        "obra":"Floating Spacces",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2007",
                        "compositor":"Parmerud+Blomsquist",
                        "pais":"Suecia",
                        "obra":"Junk",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                "titulo": "Concierto CECH",
                    "detalle":[
                        {
                        "dia":"10-20-2007",
                        "compositor":"Bryan Holmes",
                        "pais":"Chile",
                        "obra":"Ultramar",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2007",
                        "compositor":"Félix Lazo",
                        "pais":"Chile",
                        "obra":"Dos Estaciones",
                        "año":"",
                        "categoria":"Mixta",
                        "interprete":"Juan Carlos Bravo (Gr), Félix Lazo (C)"
                        },
                        {
                        "dia":"10-20-2007",
                        "compositor":"Cecilia García-Gracia",
                        "pais":"Chile",
                        "obra":"Desarme Final",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2007",
                        "compositor":"Javier Muñoz",
                        "pais":"Chile",
                        "obra":"Mandylion",
                        "año":"",
                        "categoria":"Mixta",
                        "interprete":"Valentina Wong (Coreo) (Danza)"
                        },
                        {
                        "dia":"10-20-2007",
                        "compositor":"Paola Lazo",
                        "pais":"Chile",
                        "obra":"Extensión Digital",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2007",
                        "compositor":"Felipe Otondo",
                        "pais":"Chile",
                        "obra":"Showtime",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-20-2007",
                        "compositor":"Alejandro Albornoz",
                        "pais":"Chile",
                        "obra":"Inicio",
                        "año":"",
                        "categoria":"Mixta",
                        "interprete":"Alejandra Caro (Coreo), Alejandra Agurto (Danza), Mabel Olea (Danza)"
                        },
                        {
                        "dia":"10-20-2007",
                        "compositor":"Ródrigo Cádiz",
                        "pais":"Chile",
                        "obra":"iCons",
                        "año":"",
                        "categoria":"Live Electronics",
                        "interprete":""
                        }
                    ]
                }
            ]
        },
        {
            "año":"2013",
            "fechas":"Del 8 al 12 de Noviembre",
            "nombre":"Festival Internacional de Música Electroacústica Ai Maako",
            "lugar":"UV/BAM",
            "organizador":"CECH",
            "eventos":
            [
                { 
                "titulo": "Concierto en Bienal de Artes Mediales de Santiago",
                    "detalle":[
                        {
                        "dia":"11-12-2013",
                        "compositor":"Bryan Holmes",
                        "pais":"Chile/Brasil",
                        "obra":"Glosa de Clímax Púrpura",
                        "año":"1985",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"11-12-2013",
                        "compositor":"Natasha Roberts",
                        "pais":"UK",
                        "obra":"Giant Mosquito",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"11-12-2013",
                        "compositor":"Isabel Trocellier",
                        "pais":"Francia",
                        "obra":"Pour Que le Fer Plope Sous le Feu",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"11-12-2013",
                        "compositor":"Rodrigo Cádiz",
                        "pais":"Chile",
                        "obra":"Imber",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"11-12-2013",
                        "compositor":"Natasha Barret",
                        "pais":"UK",
                        "obra":"Under the See Floor",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"11-12-2013",
                        "compositor":"Alejandro Albornoz",
                        "pais":"Chile",
                        "obra":"Abro la Escucha de Par en Par",
                        "año":"",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"11-12-2013",
                        "compositor":"Ingrid Drese",
                        "pais":"Bélgica",
                        "obra":"Paysage avec Miroir",
                        "año":"",
                        "categoria":"Audiovisual",
                        "interprete":""
                        },
                        {
                        "dia":"11-12-2013",
                        "compositor":"Cecilia García-Grácia",
                        "pais":"Chile",
                        "obra":"Las Palabras",
                        "año":"",
                        "categoria":"Audiovisual",
                        "interprete":""
                        }
                    ]
                }
            ]
        },
        {
            "año":"2017",
            "fechas":"del 14 al 15 de Octubre",
            "nombre":"Festival Internacional de Música Electroacústica Ai Maako",
            "lugar":"CCE",
            "organizador":"CECH",
            "eventos":
            [
                { 
                "titulo": "Concierto Inaugural",
                    "detalle":[
                        {
                        "dia":"10-13-2017",
                        "compositor":"Nicolas Rodríguez",
                        "pais":"Argentina",
                        "obra":"Armonías y Soldaduras",
                        "año":"2017",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2017",
                        "compositor":"Pedro Torres",
                        "pais":"Chile",
                        "obra":"La Vida está LLena de Pájaros",
                        "año":"2017",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2017",
                        "compositor":"Ignacio Salvo",
                        "pais":"Chile",
                        "obra":"Elegía",
                        "año":"2017",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2017",
                        "compositor":"Luis Martínez",
                        "pais":"Bolivia",
                        "obra":"Estudio Espectral",
                        "año":"2016",
                        "categoria":"",
                        "interprete":""
                        },
                        {
                        "dia":"10-13-2017",
                        "compositor":"Javier Party",
                        "pais":"Chile",
                        "obra":"Extempore I",
                        "año":"2013",
                        "categoria":"",
                        "interprete":""
                        }
                    ]
                },
                { 
                    "titulo": "Concierto Homenaje a José Vicente Asuar",
                    "detalle":[
                        {
                            "dia":"10-13-2017",
                            "compositor":"José Vicente Asuar",
                            "pais":"Chile",
                            "obra":"Guararia Repano",
                            "año":"1968",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-13-2017",
                            "compositor":"José Vicente Asuar",
                            "pais":"Chile",
                            "obra":"Serenata Para Mi Voz y Sonidos Sinusoidales",
                            "año":"1961",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-13-2017",
                            "compositor":"José Vicente Asuar",
                            "pais":"chile",
                            "obra":"Divertimento",
                            "año":"1967",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-13-2017",
                            "compositor":"José Vicente Asuar",
                            "pais":"Chile",
                            "obra":"Affaires de Oiseaux",
                            "año":"1976",
                            "categoria":"",
                            "interprete":""
                        }
                    ]
                },
                { 
                    "titulo": "Concierto Comunidad Electroacústica de Chile",
                    "detalle":[
                        {
                            "dia":"10-14-2017",
                            "compositor":"Alejandro Albornoz",
                            "pais":"Chile",
                            "obra":"Sheffield 17",
                            "año":"2017",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-14-2017",
                            "compositor":"Marcelo Espíndola",
                            "pais":"Chile",
                            "obra":"Puertas Adentro",
                            "año":"2017",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-14-2017",
                            "compositor":"Emilio Adasme",
                            "pais":"chile",
                            "obra":"Rastreados",
                            "año":"2017",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-14-2017",
                            "compositor":"Mika Martini/Iñaki Muñoz",
                            "pais":"Chile",
                            "obra":"Variaciones sobre Pájaros",
                            "año":"2017",
                            "categoria":"Audiovisual",
                            "interprete":""
                        },
                        {
                            "dia":"10-14-2017",
                            "compositor":"Pablo Godoy",
                            "pais":"Chile",
                            "obra":"Música para pequeño ensamble de instrumentros electrónicos DIY",
                            "año":"2017",
                            "categoria":"Live Electronics",
                            "interprete":""
                        },
                        {
                            "dia":"10-14-2017",
                            "compositor":"Renzo Filinich",
                            "pais":"Chile",
                            "obra":"A tu Memoria",
                            "año":"2017",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-14-2017",
                            "compositor":"Ricardo Tapia",
                            "pais":"Chile",
                            "obra":"Adanot",
                            "año":"2017",
                            "categoria":"Live Electronics",
                            "interprete":"GMS/FBW"
                        },
                        {
                            "dia":"10-14-2017",
                            "compositor":"José Miguel Candela",
                            "pais":"Chile",
                            "obra":"Islas Temporales- Asuntos del Alma (a José Vicente Asuar)",
                            "año":"2017",
                            "categoria":"",
                            "interprete":""
                        },
                        {
                            "dia":"10-14-2017",
                            "compositor":"Residencia Ai Maako",
                            "pais":"Chile",
                            "obra":"Obra Colectiva",
                            "año":"2017",
                            "categoria":"",
                            "interprete":""
                        }
                    ]
                }
            ]
        }
      ]
    })
}
</script>


// WEBPACK FOOTER //
// src/components/Edicionespasadas.vue